import React from 'react';
import { Outlet } from 'react-router-dom';
import ShareableLinkProvider from './providers/ShareableLink';
import ShareableLinkDataProvider from './providers/ShareableLinkData';
import ShareableLinkPage from './pages/ShareableLinkPage';
import ShareableLinkFileDownloadProvider from './providers/ShareableLinkFileDownload';
import classNames from 'classnames';
import HelmetWrapper from 'components/HelmetWrapper';
import { useTranslation } from 'react-i18next';

import './ShareableLink.router.styles.scss';

const ShareableLink: React.FC = () => {
  const classes = classNames('shareable-link-router');

  const { t } = useTranslation();

  return (
    <div className={classes}>
      <HelmetWrapper title={t('secureShare')} />
      <ShareableLinkProvider>
        <ShareableLinkDataProvider>
          <ShareableLinkPage>
            <ShareableLinkFileDownloadProvider>
              <Outlet />
            </ShareableLinkFileDownloadProvider>
          </ShareableLinkPage>
        </ShareableLinkDataProvider>
      </ShareableLinkProvider>
    </div>
  );
};

export default ShareableLink;
